import { absenceCategories } from "@msuite/utils/absences";
import { absenceStates } from "@msuite/utils/schemas";

export const categoryValues = ["all", ...absenceCategories] as const;
export const stateValues = ["all", ...absenceStates] as const;
export type AbsencesSortBy = "startDate" | "createdAt" | "name";
export type AbsenceState = (typeof stateValues)[number];
